import styled from "styled-components";
import {  V3HeadlineH5 } from "../Typography";
import {theme } from "../../theme/theme";
import SimpleBar from "simplebar-react";
import {  AuthoryColorSchemeProps, getFontColor, isContrastWithDarkHigher, UserThemableHeading } from "../ReusableStyledComponents/FontSetUtilities";
import { hexToRgba } from "../../utils/hexToRGBA";
import { AuthoryColorSchemes } from "../ProfileHero/V3ProfileHero.types";
import { SharedBorder, SharedOutlineProps } from "../ReusableStyledComponents/outline";
import { CUSTOM_FONT_SET_SIZES } from "../../utils/getFontSetLabels";

export const ECLeftSideCol = styled.div<{ $editMode: boolean, $active: boolean, $isEditingName: boolean, $dragMode?: boolean, $isSettingsIcon?: boolean, $isAddElement?: boolean, $settingsActive?: boolean, $isCheckIcon?: boolean, $hasSettingsHidden?: boolean, $alternateHover: boolean } & AuthoryColorSchemeProps>`
    display: flex;
    min-height: 40px;
    width: 100%;
    position: relative;
    border-radius: ${({ $alternateHover }) => $alternateHover ? "4px" : undefined};
    border-top-right-radius: ${({ $settingsActive }) => $settingsActive ? "6px" : undefined};
    border-bottom-right-radius: ${({ $settingsActive }) => $settingsActive ? "6px" : undefined};
    cursor:  ${({ $isEditingName }) => $isEditingName ? "text" : "pointer"};
    background: ${({ $colorVariant, $settingsActive, $active, $alternateHover, theme}) => {
        if ($colorVariant === AuthoryColorSchemes.userTheme) {
            if ($settingsActive  || ($active && $alternateHover)) return hexToRgba(theme.customization.accentcolour, 0.1);
        } else {
            if ($settingsActive  || ($active && $alternateHover)) return "rgba(255, 255, 255, 0.10)";
        }
    }};
    color: ${({ $colorVariant, $customBackgroundColor, $customDarkShade, $active, theme }) => {
        if ($colorVariant === AuthoryColorSchemes.userTheme) {
            const bgColorFinal = $customBackgroundColor || theme.customization.backgroundColor;
            return hexToRgba(getFontColor(bgColorFinal, $colorVariant, $active ? undefined : $customDarkShade ), !isContrastWithDarkHigher(bgColorFinal) && !$active ? 0.7 : 1);
        } else {
            return hexToRgba("#FFFFFF", !$active ? 0.7 : 1 );
        }
    }};
    padding: ${({ $isEditingName, $isSettingsIcon, $isAddElement, $hasSettingsHidden, $alternateHover }) => {
        return $isAddElement && !$isEditingName ? "10px 8px"
            : $isEditingName ? undefined
                : $isSettingsIcon ? "10px 8px 10px 4px"
                    : ($hasSettingsHidden || $alternateHover) ? "10px 8px" : "10px 4px 10px 8px";
    }};
    

    svg {
        path {
            stroke: ${({ $colorVariant, $settingsActive }) => {
                if ($colorVariant === AuthoryColorSchemes.userTheme) {
                    return $settingsActive ? theme.v3.colors.blue : undefined;
                } else {
                    return $settingsActive ? "white" : "rgba(255, 255, 255, 0.7)";
                }
            }};
        }
    }

    &:first-child {
        padding-left: ${({ $editMode, $dragMode, $alternateHover }) => !$editMode && !$dragMode && !$alternateHover ? "0px" : undefined};
    }

    &:after {
        content: "";
        width: ${({ $editMode, $hasSettingsHidden  }) => $editMode ? $hasSettingsHidden ? "calc(100% - 16px)" : "calc(100% - 12px)" : $hasSettingsHidden ? "calc(100% - 8px)" : "calc(100% - 4px)"};
        display: ${({ $isEditingName, $active, $dragMode, $alternateHover }) => !$active || $dragMode || $isEditingName || $alternateHover ? "none" : "block"};
        height: 3px;
        bottom: -2px;
        left: ${({ $editMode }) => $editMode ? "8px" : "0"};
        position: absolute;
        background: ${({ $colorVariant, theme }) => {
            return $colorVariant === AuthoryColorSchemes.userTheme ? theme.customization.accentcolour : "white";
        }}
    }

    &:hover {
        background: ${({ $colorVariant, $isEditingName, theme, $alternateHover}) => {
            if(!$alternateHover) return;
            if ($colorVariant === AuthoryColorSchemes.userTheme) {
                return  !$isEditingName ? hexToRgba(theme.customization.accentcolour, 0.25) : undefined;
            } else {
                return  !$isEditingName ? "rgba(255, 255, 255, 0.10)" : undefined;
            }
        }};

        color: ${({ $colorVariant, theme, $customBackgroundColor}) => {
            if ($colorVariant === AuthoryColorSchemes.userTheme) {
                return hexToRgba(getFontColor( $customBackgroundColor || theme.customization.backgroundColor, $colorVariant), 1);
            } else {
                return hexToRgba("#FFFFFF", 1 );
            }
        }};

        &:after {
            display: ${({ $isSettingsIcon, $alternateHover, $isAddElement }) => !$isSettingsIcon && !$alternateHover && !$isAddElement ? "block" : undefined};
        }

        svg {
            path {
                stroke: ${({ $colorVariant, theme }) => {
                    if ($colorVariant === AuthoryColorSchemes.userTheme) {
                        return theme ? theme.v3.colors.blue : null;
                    } else {
                        return "white";
                    }
                }};
            }
        }
    }
`;

export const UserThemableEditableItem = styled.div<AuthoryColorSchemeProps>`
    ${UserThemableHeading}
`;

export const EditableItemWrapper = styled(V3HeadlineH5) <SharedOutlineProps & {
    $editMode: boolean,
    $isAddElement: boolean,
    $isOverlay: boolean,
    $dragMode: boolean,
    $activeDrag: boolean,
    $isEditingName: boolean,
    $orientation?: "before" | "after",
    $alternateHover: boolean
}>`
    white-space: nowrap;
    position: relative;
    display: flex;
    align-items: center;
    background: ${({ $colorVariant, theme, $customBackgroundColor }) => {
        if(!!$customBackgroundColor) return $customBackgroundColor;
        return $colorVariant === AuthoryColorSchemes.userTheme ? theme.customization.backgroundColor : undefined;
    }};
    margin-right: ${({ $editMode, $alternateHover }) => $editMode ? "0px" : $alternateHover ? "10px" : "20px"};
    min-width: ${({ $isAddElement }) => $isAddElement ? "176px" : undefined};
    pointer-events: ${({ $dragMode }) => $dragMode ? "none" : undefined};
    border: 1px solid rgba(0,0,0,0);
    font-size: ${({ theme }) => {
        if (CUSTOM_FONT_SET_SIZES.includes(theme.customization.profileFontSet)) {
            return "16px";
        }
    }};

    ${({ $isOverlay , $dragMode , $isEditingName, $orientation, $colorVariant}) => {
        if (!!$orientation) return $colorVariant === AuthoryColorSchemes.userTheme ? "border: 1px dashed #2E77FF;" : "border: 1px solid white;";
        if ($isOverlay || $dragMode || $isEditingName) return SharedBorder;
    }}

    > * {
        opacity: ${({ $activeDrag }) => $activeDrag ? "0" : undefined};
    }

    a {
        color: inherit;
        text-decoration: none;
    }

    [contenteditable="true"] {
        outline: none;
        padding: 10px 8px;

        &:empty:before {
            content: attr(placeholder);
            display: block;
            color: #aaa;
        }
    }
`;


export const HomeWrapper = styled.div<{ $colorVariant: AuthoryColorSchemes, $editMode: boolean, $editingComponentID?: string }>`
    border: 1px solid rgba(0,0,0,0);
    border-radius: 6px;
`;

export const EditableSortableItemsWrapper = styled.div<
SharedOutlineProps &
{
    $editMode: boolean, 
    $dragMode: boolean,
    $editingComponentID?: string,
    $isDropdownOpen?: boolean,
    $colorVariant: AuthoryColorSchemes, 
    $alternateHover: boolean, 
    $useVerticalMode: boolean 
}>`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: ${({ $useVerticalMode }) => $useVerticalMode ? "column" : undefined};
    align-items: ${({ $useVerticalMode }) => $useVerticalMode ? "flex-start" : undefined};
    margin-bottom: 12px;
    position: relative;
    min-height: ${({ $dragMode }) => $dragMode ? "42px" : undefined};
    

    ${EditableItemWrapper} {
        flex-shrink: 0;
        border-radius: 6px;
        margin-top: ${({ $useVerticalMode }) => $useVerticalMode ? "4px" : undefined};

        &:not(:last-child) {
            border-right: 1px dashed rgba(171, 176, 186, 0);
        }
    }

    ${EditableItemWrapper} {
        @media (max-width: ${({ theme}) => theme.breakpoints.phone}px ) {
            ${SharedBorder};
        }
    }
    
    &:hover {
        ${EditableItemWrapper} {
            ${SharedBorder};
        }
    }
`;

export const AddColShortcutPos = styled.div<{ $scrollCustomColor?: string } & SharedOutlineProps>`
    position: absolute;
    right: 0;
    z-index: 2;
    top: 0;
    width: 32px;
    height: 42px;
    background:  ${({ $colorVariant, $scrollCustomColor, theme}) => {
        if ($scrollCustomColor) return $scrollCustomColor;
        if ($colorVariant === AuthoryColorSchemes.userTheme) {
            return theme.customization.backgroundColor;
        } else {
            return "rgba(8,22,43,0.6)";
        }
    }};
    ${SharedBorder}
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    cursor: pointer;

    &:before {
        pointer-events: none;
        content: '';
        position: absolute;
        background-image: linear-gradient(to right, transparent, ${({ $colorVariant, $scrollCustomColor, theme }) => {
            if ($scrollCustomColor) return $scrollCustomColor;
            if ($colorVariant === AuthoryColorSchemes.userTheme) return theme.customization.backgroundColor;
            if ($colorVariant === AuthoryColorSchemes.light) return "rgba(8,22,43,0.6)";
        }});
        opacity: 2.5; 
        height: 100%;
        transform: translateX(-100%);
        width: 25px;
        left: -1px;
        top: 0;
        z-index: 1;
    }
`;

export const AddItShortcutBackground = styled.div<{ $active?: boolean, $colorVariant: AuthoryColorSchemes }>`
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ $active }) => $active ? "rgba(46, 119, 255, 0.10)" : undefined};

    &:hover {
        background: ${({ $colorVariant }) => {
            return $colorVariant === AuthoryColorSchemes.userTheme ? "rgba(46, 119, 255, 0.10)" : "rgba(255,255,255, 0.3)";
        }};

        svg {
            polyline {
                stroke:  ${({ $colorVariant }) => $colorVariant === AuthoryColorSchemes.userTheme ? theme.v3.colors.blue : "white"};
            }
        }
    }
`;

export const ECWrapper = styled.div`
    position: relative;
    overflow: hidden;
`

export const SimpleBarWithFade = styled(SimpleBar) <{  $scrollCustomColor?: string } & AuthoryColorSchemeProps>`
    &.left-shadow {
        &:before {
            pointer-events: none;
            content: '';
            position: absolute;
            background-image: linear-gradient(to left, transparent, ${({ $colorVariant, $scrollCustomColor, theme }) => {
                if ($scrollCustomColor) return $scrollCustomColor;
                if ($colorVariant === AuthoryColorSchemes.userTheme) return theme.customization.backgroundColor;
                if ($colorVariant === AuthoryColorSchemes.light) return "rgba(8,22,43,0.6)";
            }});
            opacity: 1; 
            height: calc(100% - 10px);
            width: 30px;
            left: 0;
            top: 0;
            z-index: 1;
        }
    }

    &.right-shadow {
        &:after {
            pointer-events: none;
            content: '';
            position: absolute;
            background-image: linear-gradient(to right, transparent, ${({ $colorVariant, $scrollCustomColor, theme }) => {
                if ($scrollCustomColor) return $scrollCustomColor;
                if ($colorVariant === AuthoryColorSchemes.userTheme) return theme.customization.backgroundColor;
                if ($colorVariant === AuthoryColorSchemes.light) return "rgba(8,22,43,0.6)";
            }});
            opacity: 1; 
            height: calc(100% - 10px);
            width: 35px;
            right: 0;
            top: 0;
            z-index: 1;
        }
    }

    .simplebar-scrollbar {
        &:before {
            background: ${({ $colorVariant, theme, $customBackgroundColor }) => {
                return $colorVariant === AuthoryColorSchemes.userTheme ? hexToRgba(getFontColor($customBackgroundColor || theme.customization.backgroundColor, $colorVariant), 1) : "white";
            }};
        }
    }
`;

export const ReorderWrapper = styled.div<{ $colorVariant: AuthoryColorSchemes, $useVerticalMode: boolean} & SharedOutlineProps>`
    display: flex;
    flex-direction: ${({ $useVerticalMode }) => $useVerticalMode ? "column" : undefined};
    align-items: ${({ $useVerticalMode }) => $useVerticalMode ? "flex-start" : undefined};

    > div {
        &:nth-child(2) {
            margin-top: ${({ $useVerticalMode }) => $useVerticalMode ? "4px" : undefined};
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 8px;
            height: 42px;
            border-radius: 6px;
            cursor: pointer;
            ${SharedBorder}

            &:hover {
                background: ${({ $colorVariant }) => $colorVariant === AuthoryColorSchemes.userTheme ? "rgba(46, 119, 255, 0.10)" : "rgba(255,255,255, 0.3)"};

                svg {
                    polyline {
                        stroke: ${({ $colorVariant }) => $colorVariant === AuthoryColorSchemes.userTheme ? theme.v3.colors.blue : "white"};
                    }
                }
            }
        }
    }
`;

export const ScrollShortcutPos = styled.div<AuthoryColorSchemeProps>`
    position: absolute;
    right: 0;
    z-index: 2;
    top: 7px;
    width: 24px;
    height: 24px;
    background: ${({ $colorVariant, theme }) => {
        if ($colorVariant === AuthoryColorSchemes.userTheme) return theme.customization.backgroundColor;
        if ($colorVariant === AuthoryColorSchemes.light) return "rgba(8,22,43,1)";
    }};

    svg {
        opacity: 0.20;
        position: relative;
        left: 5px;

        stroke: ${({ $colorVariant, theme, $customBackgroundColor }) => {
            if ($colorVariant === AuthoryColorSchemes.userTheme) return getFontColor($customBackgroundColor || theme.customization.backgroundColor);
            if ($colorVariant === AuthoryColorSchemes.light) return "rgba(8,22,43,1)";
        }};
    }

    &:before {
        pointer-events: none;
        content: '';
        position: absolute;
        background-image: linear-gradient(to right, transparent, ${({ $colorVariant, theme }) => {
            if ($colorVariant === AuthoryColorSchemes.userTheme) return theme.customization.backgroundColor;
            if ($colorVariant === AuthoryColorSchemes.light) return "rgba(8,22,43,0.6)";
        }});
        opacity: 2.5; 
        height: 100%;
        transform: translateX(-100%);
        width: 25px;
        left: 4px;
        top: 0;
        z-index: 1;
    }
`;


export const ESItemsWrapper = styled.div<{ $useVerticalMode: boolean}>`
    display: flex;
    flex-direction: ${({ $useVerticalMode }) => $useVerticalMode ? "column" : undefined};
    align-items: ${({ $useVerticalMode }) => $useVerticalMode ? "flex-start" : undefined};
`;